<template>
<span>
    <contactus-hero></contactus-hero>
    <contact-form></contact-form>
   <page-footer></page-footer>
</span>
</template>
<script>
import ContactusHero from '@/components/ContactusHero'; 

import ContactForm from '@/components/ContactForm';
import PageFooter from '@/components/PageFooter';
export default {
    name :'about',
    components:{
        ContactForm,
        ContactusHero,
        PageFooter
    }

    
};
</script>


